import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientQuestionnaireControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author [Atish Bagate]
 */
export const useDashboardPatientQuestionaireStatusUpdate = () =>
  useMutationWithLoading(async (params: ArchiveMutation) =>
    new PatientQuestionnaireControllerApi(
      getConfigObject()
    ).updatePatientQuestionnaire(params?.id, params?.status, params?.xTENANTID)
  );
